/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CreditCardEligibility": {
                "values": {
                  "DO_NOT_USE": 0,
                  "WAITLIST_ELIGIBLE": 1,
                  "WAITLIST_JOINED": 2,
                  "INVITED_TO_APPLY": 6,
                  "INVITED_TO_APPLY_NOT_ELIGIBLE": 7,
                  "HAS_OFFER": 3,
                  "HAS_OFFER_NOT_ELIGIBLE": 4,
                  "HAS_CREDIT_CARD": 5,
                  "INELIGIBLE": 100
                }
              },
              "RetrieveCreditCardEligibilityRequest": {
                "fields": {}
              },
              "RetrieveCreditCardEligibilityResponse": {
                "fields": {
                  "isCreditCardEligible": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditCardEligibility": {
                    "type": ".squareup.corporate_card.service.CreditCardEligibility",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isOnWaitlist": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreditCardEligibility && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCreditCardEligibilityRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCreditCardEligibilityResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreditCardEligibility @ squareup/corporate_card/service/retrieve_credit_card_eligibility.proto at 8:1
 */
export const CreditCardEligibility = $root.lookupEnum('squareup.corporate_card.service.CreditCardEligibility').values;
/**
 * SOURCE RetrieveCreditCardEligibilityRequest @ squareup/corporate_card/service/retrieve_credit_card_eligibility.proto at 71:1
 */
export const RetrieveCreditCardEligibilityRequest = $root.lookupType('squareup.corporate_card.service.RetrieveCreditCardEligibilityRequest');
fixType(RetrieveCreditCardEligibilityRequest);
Builder.createAndAttachToType(RetrieveCreditCardEligibilityRequest);
/**
 * SOURCE RetrieveCreditCardEligibilityResponse @ squareup/corporate_card/service/retrieve_credit_card_eligibility.proto at 74:1
 */
export const RetrieveCreditCardEligibilityResponse = $root.lookupType('squareup.corporate_card.service.RetrieveCreditCardEligibilityResponse');
fixType(RetrieveCreditCardEligibilityResponse);
Builder.createAndAttachToType(RetrieveCreditCardEligibilityResponse);